import { forwardRef } from 'react';
import { useTheme } from 'styled-components';

import { Icon, Text } from '../../ui';
import { ScrollArea } from '../ScrollArea';
import { Transition, TransitionProps } from '../Transition';
import {
  StyledBackButton,
  StyledContent,
  StyledHeader,
  StyledHeaderContent,
  StyledWrapper,
} from './MenuShell.style';

interface AppShellProps {
  animation?: TransitionProps['animation'];
  children: React.ReactNode;
  visible: boolean;
  keepMounted?: boolean;
  locked?: boolean;
  title?: string;
  backButton?: {
    label: string;
    onClick: () => void;
  };
}

export const MenuShell = forwardRef<HTMLDivElement, AppShellProps>(function MenuShell(
  { title, animation = 'fade', children, keepMounted, visible = false, locked = false, backButton },
  ref
) {
  const theme = useTheme();

  return (
    <Transition animation={animation} visible={visible} keepMounted={keepMounted}>
      {title && (
        <StyledHeader>
          <StyledHeaderContent>
            {backButton && (
              <StyledBackButton onClick={backButton.onClick}>
                <Icon name="chevron---left" size="Medium" color={theme.Color.Neutrals.Dark} />
                <Text size={'Body'}>{backButton.label}</Text>
              </StyledBackButton>
            )}

            {!backButton && <Text size={'Body'}>{title}</Text>}
          </StyledHeaderContent>
        </StyledHeader>
      )}

      <StyledWrapper className="menu-shell" ref={ref} $locked={locked} $hasTitle={!!title}>
        <ScrollArea style={{ height: '100%' }} autoHide={true} className="menu-scroll-area">
          <StyledContent className="menu-content" $hasTitle={!!title}>
            {children}
          </StyledContent>
        </ScrollArea>
      </StyledWrapper>
    </Transition>
  );
});
